module.exports = __webpack_public_path__ + "img/logivialogga_transp.3b964fc6.png";